import React from 'react';
import RegisterForm from './components/register-form';
import SignUpFooter from './components/sign-up-footer';
import SignUpAside from './components/sign-up-aside';

const RegisterPage: React.FC = () => {
  return (
    <>
      {/* begin::Body */}
      <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
        <RegisterForm />
        <SignUpFooter />
      </div>
      {/* end::Body */}
        <SignUpAside/>
    </>
  );
};

export { RegisterPage as Register };
